export default __webpack_public_path__ + "static/media/document-icon.09ea1d85.png";